import React, { Fragment, useContext, useState, useEffect } from "react";
import ProfileContext from "../context/profile/profileContext";
import HeaderMenu from "./HeaderMenu";
import Modal from "./Modal";
import "./Header.css";
import { Link } from "react-router-dom";

export const Header = () => {
  const profileContext = useContext(ProfileContext);
  const { loadUser, isAuthenticated } = profileContext;

  useEffect(() => {
    loadUser();
    // eslint-disable-next-line
  }, []);

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const authLinks = (
    <Fragment>
      <li className="header-menu-item">
        <i className="fa-solid fa-user" onClick={handleOpen}></i>
      </li>
    </Fragment>
  );

  return (
    <nav>
      <Link to="/">
        <div className="nav-logo">
          <h4> BELTRACE </h4>
        </div>
      </Link>
      <ul>{isAuthenticated ? authLinks : ""}</ul>
      <Modal
        open={open}
        proc="fs-modal"
        onClose={handleClose}
        component={<HeaderMenu />}
      />
    </nav>
  );
};
